import React from 'react'

import { Item } from '@factorialco/deprecated-design-system'
import { A3innuvaCompanyLeaveTypeFragment } from 'generated/resources/graphql'
import { lowerCase } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { MappingTable } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/CodeFillers/MappingTable'
import { A3InnuvaMapping } from 'modules/payroll_integrations_a3innuva/lib/types'

interface AbsenceItemProps {
  companyLeaves: A3innuvaCompanyLeaveTypeFragment[]
  mappings: A3InnuvaMapping[]
  options: Item[]
  onMappingChanged: (mappings: A3InnuvaMapping[]) => void
}

export const AbsenceItem = ({
  companyLeaves,
  mappings,
  options,
  onMappingChanged,
}: AbsenceItemProps) => {
  const createMapping = (factorialAbsenceId: string, a3AbsenceId: string): A3InnuvaMapping => {
    return {
      factorial_id: factorialAbsenceId,
      a3innuva_id: a3AbsenceId,
    }
  }

  const setFormValues = (selectedItem: Item, leaveItem: A3innuvaCompanyLeaveTypeFragment) => {
    const factorialAbsenceId = leaveItem.id.toString()
    const a3AbsenceId = selectedItem.value.toString()
    let isAbsenceMapped = false
    let newMappings: A3InnuvaMapping[] = []

    newMappings = mappings.reduce((filteredMappings, mapping) => {
      const newMapping = { ...mapping }
      if (newMapping.factorial_id !== factorialAbsenceId) {
        filteredMappings.push(newMapping)
        return filteredMappings
      }

      isAbsenceMapped = true
      // If the value selected is none, we remove the mapping
      if (selectedItem.value === '') return filteredMappings

      newMapping.a3innuva_id = a3AbsenceId
      return filteredMappings
    }, newMappings)

    if (!isAbsenceMapped) {
      newMappings.push(createMapping(factorialAbsenceId, a3AbsenceId))
    }

    onMappingChanged(newMappings)
  }

  const findSelection = (absenceId: string) => {
    const mappingsById = Object.fromEntries(
      (mappings || []).map((mapping) => [mapping.factorial_id, mapping])
    )
    const currentMapping = mappingsById[absenceId]
    if (!currentMapping) return ''
    const selectedOption = options.find((option) => option.value === currentMapping.a3innuva_id)
    return selectedOption?.label || ''
  }

  return (
    <MappingTable
      title={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.mapping_table.a3innuva_fields'
      )}
      items={companyLeaves}
      options={options}
      getItemId={(item) => item.id.toString()}
      getItemLabel={(item) => item.translatedName || lowerCase(item.name)}
      onSelect={setFormValues}
      findSelection={findSelection}
      selectPlaceholder={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.cost_center.select'
      )}
    />
  )
}
